import { useNavigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react"; // used to integrate STS login
import { constants } from "../config/index";

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = constants.AUTH0_DOMAIN;
  const clientId = constants.AUTH0_CLIENT_ID;
  let connection = constants.AUTH0_CONNECTION;
  const navigate = useNavigate();

  const query = new URLSearchParams(window.location.search);
  let connectionFromQuery = query.get("connection");
  if (connectionFromQuery) {
    connection = connectionFromQuery;
  } else {
    connectionFromQuery = "";
  }

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
    localStorage.setItem("connection", connectionFromQuery);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      onRedirectCallback={onRedirectCallback}
      redirectUri={window.location.origin}
      useRefreshTokens={true}
      connection={connection}
      cacheLocation="localstorage"
      scope="openid profile email offline_access read:getServices"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
